/*
 * @Author: xieyu7
 * @Date: 2019-01-22 11:18:57
 * @Last Modified by: shanlu
 * @Last Modified time: 2021-07-36 14:21:55
 */
import request from '../utils/service'
import { clientTYPE } from './constant.js'
import api_mine from '@/api/mine.js'
import wx from 'weixin-js-sdk'
import gcoord from 'gcoord'

import store from '@/store/index.js'
import weui from 'weui.js'

/**
 * 格式化时间戳
 * @param {String} time
 * @param {String} cFormat {y}-{m}-{d} {h}:{i}:{s}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
   * 从location上获取参数
   * @param {String} name
   */
export function getLocationQuery(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') // 构造一个含有目标参数的正则表达式对象
  const r = window.location.href.split('?')[1] ? decodeURI(window.location.href.split('?')[1]).match(reg) : null // 匹配目标参数
  if (r != null) return unescape(r[2]); return null // 返回参数值
}

export function getLocal(name) {
  return localStorage.getItem(name)
}
export function setLocal(name, value) {
  return localStorage.setItem(name, value)
}

export function getApplicationInfo() {
  return request({
    url: '/basic/v2/api/applicationInfos',
    method: 'get',
    params: { type: 1 }
  })
}
export function getAKey() {
  return request({
    url: '/basic/v2/api/getAk',
    method: 'get'
  })
}
export function getOpenId(code) {
  return request({
    url: '/api/v1/getOpenid',
    method: 'post',
    data: {
      type: 1,
      authCode: code
    }
  })
}

/* 获取微信公众号JSSDK */
export function setJsapiSign(store) {
  const promise = new Promise((resolve) => {
    /* mock模式下不进行wxapi认证，即不能进行wxapi相关功能调试 */
    if (process.env.VUE_APP_MOCK) {
      store.commit('complateConfig')
      resolve()
      return
    }
    if (store.getters.isWXConfig) {
      resolve()
      return
    }
    if (localStorage.getItem('clientType') != clientTYPE.WX) {
      resolve()
      return
    }
    if (document.getElementById('JSSdk') == null) { // 未引入js文件
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = 'JSSdk'
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null
            getJsApiSign(store, resolve)
          }
        }
      } else {
        script.onload = function() {
          getJsApiSign(store, resolve)
        }
      }
      script.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js'
      document.body.appendChild(script)
    } else { // 已引入文件
      getJsApiSign(store, resolve)
    }
  })
  return promise
}
/**
 * 请求jsapi签名
  */
function getJsApiSign(store, resolve) {
  // 判断是否是扫码领劵失败页面  不是扫码领券失败页面才会获取应用基础信息   防止页面报错
  if (encodeURI(window.location.href).indexOf('scanQRCodeFailed') == -1) {
    request({
      url: '/basic/v2/api/jsapiSigns',
      method: 'get',
      params: { url: encodeURI(window.location.href.split('#')[0]) }
    }).then(resp => {
      const data = resp.data
      // eslint-disable-next-line no-undef
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: [
          'scanQRCode',
          'getLocation',
          'chooseImage',
          'uploadImage',
          'chooseWXPay',
          'closeWindow'
        ], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表
      })
      // eslint-disable-next-line no-undef
      wx.ready(function() {
        store.commit('complateConfig')
        resolve()
      })
      // eslint-disable-next-line no-undef
      wx.error(function(err) {
        console.error(err)
        resolve()
      })
    })
  }
}

/**
 * 节流函数
 * @param {Function} fn
 * @param {Number} inter
 */
export function _throttle(fn, inter) {
  let last
  let timer
  const interval = inter || 200
  return function() {
    const th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

// 支付宝JSBridge注入
// 由于机制问题，JSAPI注入是异步过程，时序无法保证。
// 如果使用原生AlipayJSBridge接口，需要先监听AlipayJSBridgeReady事件后再调用原生JSAPI接口。
export function AliReady(callback) {
  // 如果jsbridge已经注入则直接调用
  if (window.AlipayJSBridge) {
    callback && callback()
  } else {
    // 如果没有注入则监听注入的事件
    document.addEventListener('AlipayJSBridgeReady', callback, false)
  }
}
/**
 *
 * @param {String} orderStr
 * @param {Function} callback
 */
export function alipayApp(orderStr, callback) {
  AliReady(function() {
    // eslint-disable-next-line no-undef
    AlipayJSBridge.call('tradePay', {
      tradeNO: orderStr
    }, function(result) {
      callback(result)
    })
  })
}

export function alipayAppClose() {
  AliReady(function() {
    // eslint-disable-next-line no-undef
    AlipayJSBridge.call('closeWebview')
    // AlipayJSBridge.call('closeWebview');
  })
}

/**
 * 跳转至高德地图网页版
 * @param {Object} originPos {lat,lng}
 * @param {Object} destinationPos {lat,lng}
 * @param {String} destinationName
 */
export function JumpToMapApp(originPos, destinationPos, destinationName, type) {
  let url = ''
  if (type == '高德') {
    url = 'http://uri.amap.com/navigation?to=' + destinationPos.lng + ',' + destinationPos.lat + ',' + destinationName + '&mode=car&src=nyx_super&coordinate=wgs84' // 高德
  } else {
    const locationCity = localStorage.getItem('locationCity')
    const newOriginPos = gcoord.transform(
      [originPos.lat, originPos.lng], // 经纬度坐标
      gcoord.WGS84, // 当前坐标系
      gcoord.BD09LL // 目标坐标系
    )
    console.log(originPos)
    console.log(newOriginPos)
    const newDestinationPos = gcoord.transform(
      [destinationPos.lat, destinationPos.lng], // 经纬度坐标
      gcoord.WGS84, // 当前坐标系
      gcoord.BD09LL // 目标坐标系
    )
    console.log(destinationPos)
    console.log(newDestinationPos)
    // url = `http://api.map.baidu.com/direction?origin=latlng:${newOriginPos.lat},${originPos.lng}|name:我的位置&destination=${destinationPos.lat},${destinationPos.lng}&mode=driving&region=${locationCity}&output=html&src=Hikvision|HikParking&coord_type=wgs84`; //百度
    url = `http://api.map.baidu.com/direction?origin=latlng:${originPos.lat},${originPos.lng}|name:我的位置&destination=${newDestinationPos[0]},${newDestinationPos[1]}&mode=driving&region=${locationCity}&output=html&src=Hikvision|HikParking&coord_type=bd09ll` // 百度
  }
  // return false
  window.location.href = url
}

/*  获取地理位置定位 */
export function getGeoLocation() {

}
/** 设置cookie
 * @param {String} cname
 * @param {String} cvalue
 * @param {Number} exdays
 *
 **/
export function setCookie(cname, cvalue, exdays = 365) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
/** 获取cookie
 * @param {String} cname
 *
 **/
export function getCookie(cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return ''
}
/** 设置cookie
 * @param {String} cname
 *
 **/
export function delCookie(cname) {
  const d = new Date()
  d.setTime(d.getTime() - 1)
  const expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + '' + '; ' + expires
}

export function hasSpecialCharacters(str) {
  // eslint-disable-next-line no-useless-escape
  const reg = /[\/\\:\*?\"\<\'>]/
  const spaceReg = /^\S.*\S$/g
  if (str === '' || !str) {
    return false
  } else if (reg.test(str)) {
    return '不能包含\' / \\ : * ? " < >字符'
  } else if (str.toString().split('').length === 1) {
    return str === ' ' ? '首尾不能有空格' : false
  } else if (!spaceReg.test(str)) {
    return '首尾不能有空格'
  }
  // return reg.test(str) ? '不能包含 \\ / : * ? < | % > & + -等字符' : reg.test(str)
  //  ' / \ : * ? " < >
  // return reg.test(str) ? '不能包含\' \" / \\ : * ? < >空格字符' : reg.test(str)
}

/**
 * 校验身份证
 * @param {String} val
 * @returns {Boolean}
 */
export function availableIdCard(val) {
  if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(val)) {
    return '身份证长度或格式错误'
  }
  var sum = 0
  var weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  var codes = '10X98765432'
  for (var i = 0; i < val.length - 1; i++) {
    sum += val[i] * weights[i]
  }
  var last = codes[sum % 11] // 计算出来的最后一位身份证号码
  if (val[val.length - 1] !== last) {
    return '身份证号非法'
  }
  return false
}

/* 动态加载高德地图 */
export function setAMap() {
  const promise = new Promise((resolve) => {
    if (document.getElementById('AMap') == null) { // 未引入js文件
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = 'AMap'
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null
            resolve()
          }
        }
      } else {
        script.onload = function() {
          resolve()
        }
      }
      script.src = 'https://webapi.amap.com/maps?key=6e9c7e0bbd34594333b2ac40b50eb5ab&v=1.4.4&plugin=AMap.Geolocation,AMap.Autocomplete,AMap.PlaceSearch,AMap.PolyEditor,AMap.CircleEditor'
      document.body.appendChild(script)
    } else { // 已引入文件
      resolve()
    }
  })
  return promise
}

function setCookie_(cname, cvalue, exdays = 365) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
/* 用户免登录 自动登录 */
export function loginAutomatic(self, cb) {
  const _reqJson = JSON.parse(self.$route.query.reqJson || '{}')
  if (_reqJson.ticket) {
    const param = {
      ticket: _reqJson.ticket,
      openid: localStorage.getItem('openid')
    }
    api_mine.getToken(param).then(res => {
      if (res && parseInt(res.code) === 200) {
        setCookie_('token', res.data.token)
        setCookie_('refreshToken', res.data.refreshToken)
      }
    }).finally(() => {
      if (cb) {
        cb()
      }
    })
  } else {
    if (cb) {
      cb()
    }
  }
}

/* 选择图片并上传 返回一个promise对象*/
/**
 * @params null
 * @output String picUrl // 上传服务器成功后图片地址
 * */
export function ChooseImageNative() {
  return new Promise((resolve, reject) => {
    if (getLocal('clientType') == clientTYPE.WX) {
      setJsapiSign(store).then(() => {
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {
            // eslint-disable-next-line
                  wx.getLocalImgData({
              localId: res.localIds[0].toString(),
              success: function(resp) {
                const localData = resp.localData.substring(resp.localData.indexOf(',') + 1) // 去掉base64头部
                const suffix = resp.localData.substring(resp.localData.indexOf('/') + 1, resp.localData.indexOf(';')) // 获取图片类型png
                const loading = weui.loading('正在上传')
                request({
                  url: '/basic/v2/api/pictures',
                  timeout: 30000,
                  method: 'post',
                  data: { // 上传图片资源
                    fileData: localData,
                    suffix: suffix == '/' ? 'jpg' : suffix
                  }
                }).then(ret => {
                  resolve(ret.data.picUrl)
                }).finally(() => {
                  loading.hide()
                })
              }
            })
          }
        })
      })
    } else if (getLocal('clientType') == clientTYPE.ALI) {
      AliReady(() => {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('photo', {
          dataType: 'dataURL',
          imageFormat: 'jpg',
          count: 1
        }, result => {
          if (result.error) {
            reject()
            return
          }
          /* 此处获取的dataURL 不包含base64头部信息 */
          const loading = weui.loading('正在上传')
          request({
            url: '/basic/v2/api/pictures',
            method: 'post',
            timeout: 30000,
            data: { // 上传图片资源
              fileData: result.dataURL,
              suffix: 'jpg'
            }
          }).then(ret => {
            resolve(ret.data.picUrl)
          }).finally(() => {
            loading.hide()
          })
        })
      })
    }
  })
}

/* 预览图片 */
/**
 * @param current int 默认展示第几张
 * @param urls Array 图片数组['url','url']
 */
export function previewImageNative(current, urls) {
  const currentUrl = urls[current] || ''
  if (getLocal('clientType') == clientTYPE.WX) {
    setJsapiSign(store).then(() => {
      wx.previewImage({
        currentUrl,
        urls
      })
    })
  } else if (getLocal('clientType') == clientTYPE.ALI) {
    AliReady(() => {
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call('imageViewer',
        {
          images: urls.map(url => { return { u: url, t: '' } }),
          init: current
        })
    })
  }
}

/* 扫码 */
export function ScanNative(_this) {
  if (getLocal('clientType') == clientTYPE.WX) {
    setJsapiSign(store).then(() => {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        // scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          window.location.href = result
        },
        complete: function() {
          _this.$router.push('/mine')
        }
      })
    })
  } else if (getLocal('clientType') == clientTYPE.ALI) {
    AliReady(() => {
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call('scan', {
        scanType: ['qrCode'],
        actionType: 'scanAndRoute'
      }, function(result) {
        if (!result.error) {
          window.location.href = result.resultStr
        }
        _this.$router.push('/mine')
      })
    })
  }
}
